import { render, staticRenderFns } from "./DashboardEditItem.vue?vue&type=template&id=3053dfc6&scoped=true&"
import script from "./DashboardEditItem.vue?vue&type=script&lang=ts&"
export * from "./DashboardEditItem.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardEditItem.vue?vue&type=style&index=0&id=3053dfc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3053dfc6",
  null
  
)

export default component.exports